import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const DivisionModal = ({ show, onClose, onSave, initialData, departments = [] }) => {
  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    selectedDepartments: [],
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id,
        name: initialData.name,
        selectedDepartments: initialData.departments?.map(d => d.id) || [],
      });
    } else {
      setFormData({ id: 0, name: "", selectedDepartments: [] });
    }
  }, [initialData, show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name) {
      alert("Please enter division name!");
      return;
    }
    // Gửi dữ liệu lên backend
    onSave({
      id: formData.id,
      name: formData.name,
      selectedDepartments: formData.selectedDepartments,
    });
  };

  const handleDepartmentToggle = (deptId) => {
    setFormData((prev) => {
      const exists = prev.selectedDepartments.includes(deptId);
      return {
        ...prev,
        selectedDepartments: exists
          ? prev.selectedDepartments.filter((id) => id !== deptId)
          : [...prev.selectedDepartments, deptId],
      };
    });
  };

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>{initialData ? "Edit Division" : "Add Division"}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Division Name</Form.Label>
            <Form.Control
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              placeholder="Enter division name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Departments</Form.Label>
            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: "5px",
                padding: "0.5rem",
              }}
            >
              {departments.length > 0 ? (
                departments.map((dept) => (
                  <Form.Check
                    key={dept.id}
                    type="checkbox"
                    id={`dept-${dept.id}`}
                    label={dept.name}
                    checked={formData.selectedDepartments.includes(dept.id)}
                    onChange={() => handleDepartmentToggle(dept.id)}
                  />
                ))
              ) : (
                <div className="text-muted">No departments available</div>
              )}
            </div>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button type="submit" variant="primary">
            {initialData ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DivisionModal;